import React from 'react';
import { useAuthUserContext } from '../../providers';
import { UserType } from '../../types';
import { useTitle } from '../../hooks/useTitle';
import DonorReviews from './DonorReviews';
import DoneeReviews from './DoneeReviews';

const MypageReviews = () => {
  const authUser = useAuthUserContext().user;
  const isDonee = authUser?.userType === UserType.Donee;

  useTitle('Ton Bébé | レビュー');

  return (
    <main className="sub">
      { isDonee ? <DoneeReviews /> : <DonorReviews /> }
    </main>
  );
};

export default MypageReviews;
